import React, { useState } from 'react';
import { toast } from 'react-toastify';

import { Modal } from '../Modal';
import { retrieveCSRFToken } from '../../utils/ajax';

const DeleteProjectModal = ({ project, showModal, onSuccess, onCancel }) => {
  const { id: projectId } = project;
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState(null);
  const deleteProject = async () => {
    setIsDeleting(true);
    setError(null);

    try {
      const response = await fetch(`/api/projects/${projectId}/`, {
        method: 'DELETE',
        headers: {
          'X-CSRFToken': retrieveCSRFToken(),
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        toast.success('You have deleted the project');
        return onSuccess();
      }

      setError('something went wrong trying to delete the project...');
      console.error('### project delete failed', response);
    } catch {}
    finally {
      setIsDeleting(false);
    }
  }

  return (
    <Modal showModal={showModal}>
      <h1 className="title">Are you sure?</h1>

      <div className="block">
        <span>This will permanently delete your project: </span>
        <span className="is-italic">{project.name}</span>
      </div>

      {error && (
        <div className="notification block">
          <p>{error}</p>
        </div>
      )}

      <div className="buttons">
        <button type="submit"
          className="button is-danger"
          disabled={isDeleting}
          onClick={deleteProject}
        >
          Delete
        </button>
        <button type="button" className="button" onClick={onCancel}>Cancel</button>
      </div>
    </Modal>
  );
}

export default DeleteProjectModal;
